import { AxiosInstanceProvider } from '../../../core/hooks';
import { mapPaginationViewToApiModel, PaginationViewModel } from '../../../core/model';
import { extractTotalCountHeaderFromAxiosHeader } from '../../../core/utils';
import { ItsmHttpQueryConfig } from '../../config';
import { ItsmNetworkServiceIncidentApiModel } from '../../model';

export interface ItsmNetworkServiceIncidentsHttpGetPayloadModel {
  customerId: number;
  pagination: PaginationViewModel;
}

export type ItsmNetworkServiceIncidentsHttpGetResponseModel = {
  data: ItsmNetworkServiceIncidentApiModel[];
  total: number;
};

export const getItsmNetworkServiceIncidents = async (
  axios: AxiosInstanceProvider,
  { customerId, pagination }: ItsmNetworkServiceIncidentsHttpGetPayloadModel,
): Promise<ItsmNetworkServiceIncidentsHttpGetResponseModel> => {
  const url = ItsmHttpQueryConfig['GetItsmNetworkServiceIncidents'].url.replace('{customerId}', customerId.toString(10));
  const requestConfiguration = {
    params: mapPaginationViewToApiModel(pagination),
  };
  const response = await axios().get<ItsmNetworkServiceIncidentApiModel[]>(url, requestConfiguration);
  return {
    data: response.data,
    total: extractTotalCountHeaderFromAxiosHeader(response),
  };
};